module.exports = __webpack_public_path__ + "static/media/480.b950df64.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-potted-plant/light/480.png
// module id = 2370
// module chunks = 2